import { compose, createStore, applyMiddleware } from 'redux';
import withDependencies from '@factorin/container.macro';

import { createRootSaga, sagaMiddleware, abortSagas } from '../state/sagas';
import { createRootReducer } from '../state/reducer';


const reduxDevToolsCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

export const store = withDependencies((state, history) => {
    if (module.hot && window.$reduxStore) {
        const oldStore = window.$reduxStore;
        abortSagas(oldStore);
        oldStore.replaceReducer(createRootReducer(state, history));
        sagaMiddleware.run(createRootSaga(state));
        return oldStore;
    }

    const composeEnhancers = reduxDevToolsCompose || compose;
    const newStore = createStore(
        createRootReducer(state, history),
        composeEnhancers(applyMiddleware(...state.middleware, sagaMiddleware)),
    );
    sagaMiddleware.run(createRootSaga(state));

    if (module.hot)
        window.$reduxStore = newStore;

    return newStore;
});
